<template>
  <div class="main">
    <div class="main_header">
      <div class="main_header_title" >
        <!-- @click="$router.push('/')" -->
        <title v-if="$route.path!='/home/schoolAnalyse' && $route.path!='/home/cityTotal'">
          {{title}}
        </title>
        <title v-else>
         {{realname}}职业教育铸魂育人计划项目 
        </title>
      </div>
      <div class="main_header_button" v-if="$route.path!='/home/schoolAnalyse'">
        <div v-for="(item, index) in list" :class="item.class" :key="index">
          <div
            :style="
              i.path == $route.path
                ? 'background:url(' +
                  item.activeBg +
                  ');background-size:100% 100%;'
                : ''
            "
            style="cursor: pointer"
            @click="go(i)"
            v-for="(i, ind) in item.children"
            :key="index + '' + ind"
          >
            {{ i.title }}
          </div>
        </div>
      </div>
      <div class="back-back" @click="goBackIndex" :title="返回" v-if="$route.path!='/home/schoolAnalyse'"><i class="el-icon-back" ></i></div>
      <div class="back-home" @click="goBackHome" v-if="$store.state.role == 'school-role' && $route.path=='/home/schoolAnalyse'"></div>
      <div class="back-home" @click="goBackHomes" v-if="$store.state.role != 'school-role' && $route.path=='/home/schoolAnalyse'"></div>
    </div>

    <div class="main_content" :style="$route.path!='/home/schoolAnalyse'?'':'overflow-x:auto;'"><router-view></router-view></div>
  </div>
</template>
<script>
import { LogOut } from "@/api/index";
import { mapState } from 'vuex';
export default {
   computed: {
    ...mapState({
      // 将 store 中的某些 state 映射到组件的计算属性
      user: state => state.user
    })
  },
  data() {
    return {
    	title:'山西省职业教育铸魂育人计划项目监测与管理平台',
      list: [
        {
          class: "main_header_button_left",
          activeBg: require("@/assets/images/bigData/select2.png"),
          children: [
            {
              title: "思政工作室数据分析",
              path: "/home/BszStudio",
            },
            {
              title: "思政微课数据分析",
              path: "/home/BszMicro",
            },
          ],
        },
        {
          class: "main_header_button_right",
          activeBg: require("@/assets/images/bigData/right_select.png"),
          children: [
            {
              title: "特色文化育人品牌数据分析",
              path: "/home/BeducationBrand",
            },
            {
              title: "数据分析",
              path: "/home/index",
            },
          ],
        },
      ],
      realname:'',

    };
  },
   watch: {
    '$route'(to, from) {
        console.log(to);
        if(to.path=='/home/schoolAnalyse'){
            if(this.$route.query.name){
             this.realname=this.$route.query.name
            }
        }else if(to.path=='/home/cityTotal'){
          if(this.$route.query.name){
            console.log(this.$route.query.name);
             this.realname=this.$route.query.name
            }
        }
        this.$forceUpdate();
    }
  },
  methods: {
    go(i) {
      i.path && this.$router.push({ path: i.path });
      if(i.title=='数据分析'){
      	 this.title='山西省职业教育铸魂育人计划项目监测与管理平台';
      }else{
      	 this.title=i.title;
      }
     
    },
    goBackIndex(){
       this.$router.push('/personalCenter/szStudio');
    },
    goBackHome(){
       this.$router.go(-1);
    },
    goBackHomes(){
        this.$router.push('/home/index');
    },
    gologout(){
    	LogOut().then((res) => {
        if (res.code === 200) {
          window.sessionStorage.clear();
          this.$store.state.token = null;
          this.$router.push("/login");
        }
      });
    }
  },
  mounted() {
    if(this.$route.path!='/home/schoolAnalyse' &&  this.$route.path!='/home/cityTotal'){
        if(this.$store.state.role != 'education-guide-role'){
            this.gologout();
        }
    }else{
      if(this.$route.query.name){
         this.realname=this.$route.query.name
      }
      this.$forceUpdate();
      //  if(this.$store.state.role !== 'school-role'){
      //       this.gologout();
      //   }
    }
  },
};
</script>
<style lang="scss" scoped>
.back-back{
  position: absolute;
    top: 26px;
    right: 10px;
    width: 36px;
    height: 36px;
    background: #0157D5;
    border-radius: 50%;
    text-align: center;
    font-size: 16px;
    line-height: 36px;
    cursor:pointer;
    color:#fff;
    transition: transform 0.3s ease-out;
}
.back-back:hover{
    transform: translateY(-3px);
}
.main {
  height: 100vh;
  width: 100vw;
  background: url("~@/assets/images/bigData/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  &_header {
    width: 100%;
    height: 84px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    background: radial-gradient(0% 0% at 0% 0%, #002268 0%);
    &_title {
      width: 55%;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-clip: text;
      background: url("~@/assets/images/bigData/header.png") no-repeat;
      background-size: 100% 130%;
      title {
        cursor: pointer;
        display: flex;
        text-align: center;
        font-weight: bold;
        margin-bottom: 30px;
        align-content: center;
        height: 70%;
        text-align: center;
        z-index: 2;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 1.68vw;
        text-align: center;
        background: linear-gradient(to bottom, #ffffff 0%, #00f6ff 100%);
        color: transparent;
        background-clip: text;
      }
    }
    &_button {
      position: absolute;
      left: 0;
      width: 100%;
      bottom: 2vh;
      padding: 0 40px;
      display: flex;
      justify-content: space-between;
      pointer-events: none;
      > div {
        width: 26vw;
        height: 40px;
        display: flex;
        align-content: center;
        justify-content: space-between;
        pointer-events: all;
        > div {
          font-family: MicrosoftYaHei;
          font-size: 0.9vw;
          font-weight:600;
          color: #d8feff;
          text-align: left;
          font-style: normal;
          text-transform: none;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      &_left > div {
        background: url("~@/assets/images/bigData/select.png") no-repeat;
        background-size: 100% 100%;
      }
      &_right > div {
        background: url("~@/assets/images/bigData/right_button.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  &_content {
    padding: 0.5vh 1vw;
    left: 0px;
    position: absolute;
    bottom: 0;
    height: calc(100vh - 84px);
    width: 100vw;
    display: flex;
  }
}
::-webkit-scrollbar {
  width: 0px; /* 滚动条宽度 */
}
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道背景色 */
  border-radius: 10px; /* 可选：轨道圆角 */
}
::-webkit-scrollbar-thumb {
  background: #888; /* 滚动条颜色 */
  border-radius: 10px; /* 可选：滚动条圆角 */
  &::hover {
    background: #555; /* 鼠标悬停时滚动条颜色 */
  }
}
.back-home {
      width: 154px;
      height: 46px;
      line-height: 46px;
      background: url(~@/assets/images/back-home.png)
        no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: absolute;
      right: 23px;
      top: 10px;
      cursor: pointer;
    }
* {
  transform: translate3d(0, 0, 0);
}
</style>